import { GenderType } from "../../../api/accountants/models";

export const CARD_DESCRIPTOR_BY_GENDER_MAP: Record<GenderType, string> = {
  female: "Twoja księgowa",
  male: "Twój księgowy",
};
